import { FontCategory } from '@quicktools/shared-components/data/fonts';

const props = {
  canonicalPath: 'text/font-generator/case-converter/',
  headTitle: 'Free Case Converter',
  headDescription:
    'Transform any text between various letter cases with our free Case Converter tool. Copy and paste your preferred font and use it as desired.',
  heading: 'Free Case Converter',
  description:
    'Quickly transform your text to UPPERCASE, lowercase, Sentence case, Title Case, and more. Try it out and edit your content more efficiently.',
  selectedCategory: FontCategory.Lettercases,
  inputPlaceholder: 'Convert your letters here…',
};

export default props;
